import { NgModule } from '@angular/core';

import { ModalVirtualTourComponent } from './modal-vitual-tour.component';

@NgModule({
  imports: [ModalVirtualTourComponent],
  exports: [ModalVirtualTourComponent],
  declarations: [],
  providers: [],
})
export class ModalVirtualTourModule { }
